import React from "react";
import "./footer.css";
import { Link } from "react-router-dom";
import {
  FaPhoneAlt,
  FaEnvelope,
  FaMapMarkerAlt,
  FaFacebookF,
  FaInstagram,
  FaLinkedinIn,
} from "react-icons/fa";

const FooterSection = () => {
  return (
    <footer className="modernFooter">
      <div className="footerContainer">
        {/* Brand */}
        <div className="footerBrand">
          <img
            src="/Images/logo/logo.png"
            alt="Mini and Jone"
            className="footerLogo"
          />
          <p>
            At Mini and Jone  Hospitality, we specialize in delivering seamless travel solutions with a focus on trust, quality, and exceptional service. Your journey is our priority.
          </p>
        </div>

        {/* Links */}
        <div className="footerLinks">
          <h4>Explore</h4>
          <Link to="/">Home</Link>
          <Link to="/about-us">About Us</Link>
          <Link to="/contact">Contact</Link>
          <Link to="/privacy-policy">Privacy Policy</Link>
          <Link to="/terms-conditions">Terms & Conditions</Link>
        </div>

        {/* Destinations */}
        <div className="footerLinks">
          <h4>Top Destinations</h4>
          <Link to="/andaman-and-nicobar">Andaman and Nicobar</Link>
          <Link to="/kerala">Kerala</Link>
          <Link to="/northeast">North East</Link>
          <Link to="/lakshadweep">Lakshadweep</Link>
          <Link to="/ladakh">Ladakh</Link>
        </div>

        {/* Contact */}
        <div className="footerContact">
          <h4>Get in Touch</h4>
          <p>
            <FaMapMarkerAlt className="footerContact-Icons" /> #234, 6th Main, Behind Vidyapeeta Gururaja Layout, Banashankari 3rd stage Bangalore 560028 , Karnataka, INDIA
          </p>
          <p>
            <FaPhoneAlt className="footerContact-Icons"  /> <a href="tel:+919599408232">+91-9980944799</a>
          </p>
          <p>
            <FaEnvelope className="footerContact-Icons" />{" "}
            <a href="mailto:sales@miniandjone.com">
              sales@miniandjone.com
            </a>
          </p>
          {/* <div className="socialIcons">
            <a href="#"><FaFacebookF /></a>
            <a href="#"><FaInstagram /></a>
            <a href="#"><FaLinkedinIn /></a>
          </div> */}
        </div>
      </div>
    </footer>
  );
};

export default FooterSection;
